export const isRenderingOnServer = () => typeof window === 'undefined';
